export default __webpack_public_path__ + "static/media/ISWEC-11.61bedef2.pdf";